import { render, staticRenderFns } from "./networks-list.vue?vue&type=template&id=2778b800&scoped=true&"
import script from "./networks-list.vue?vue&type=script&lang=ts&"
export * from "./networks-list.vue?vue&type=script&lang=ts&"
import style0 from "./networks-list.vue?vue&type=style&index=0&id=2778b800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2778b800",
  null
  
)

export default component.exports